import DemoTravelRuleTable from './DemoTravelRuleTable'

export default DemoTravelRuleTable
